import { Route } from "react-router-dom";
import DashboardTab from "./tabs/DashboardTab";
import StartAConversationTab from "./tabs/ProfileSettingsContactInfoTab";
import DashboardLayout from "./DashboardLayout";
import { sessionView } from "../../lib/bandung/api/session";
import { testSessionLoader } from "../../lib/bandung/loaders/helpers";
import InboxTab from "./tabs/InboxTab";
import FavoritesTab from "./tabs/FavouritesTab";
import ProfileSettingsAccountTab from "./tabs/ProfileSettingsAccountTab";
import ProfileSettingsContactInfoTab from "./tabs/ProfileSettingsContactInfoTab"
import UserCompaniesTab from "./tabs/UserCompaniesTab";
import UserCreateCompaniesTab from "./tabs/UserCreateCompaniesTab";

const dashboardComponentLoader = async (params) => {
  await testSessionLoader(params);
  const userEntityRes = await sessionView();
  const userEntity = userEntityRes.data;
  return { userEntity };
};

const dashboardRoutes = (
  <Route id="dashboardComponent" loader={dashboardComponentLoader}>
    <Route index element={<DashboardTab />} loader={testSessionLoader} />

    {/* Added for Inbox, Favorites and profile Settings */}
    <Route path="inbox" element={<InboxTab />} loader={testSessionLoader} />
    <Route
      path="favourites"
      element={<FavoritesTab />}
      loader={testSessionLoader}
    /> 
    <Route
      path="profileSettings_contact"
      element={<ProfileSettingsContactInfoTab />}
      loader={testSessionLoader}
    />
    <Route
      path="profileSettings_account"
      element={<ProfileSettingsAccountTab />}
      loader={testSessionLoader}
    />

    {/* Added Owned Companies Tab */}
    <Route
      path="ownedCompanies_view"
      element={<UserCompaniesTab />}
      loader={testSessionLoader}
    />

    {/* Added Create Companies Tab */}
    <Route
      path="ownedCompanies_create"
      element={<UserCreateCompaniesTab />}
      loader={testSessionLoader}
    />
    
  </Route>

);

const DashboardComponent = ({ ...props }) => {
  return <DashboardLayout {...props} />;
};

export { dashboardRoutes };
export default DashboardComponent;


